import http from "../plugins/Axios";

export default {
  actions: {
    async createCategory(_, payload) {
      try {
        const {
          data: { data },
        } = await http.post("product-category/save", payload);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
